var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-box",style:('width:' + _vm.nWidth + ';height:' + _vm.nHeight),attrs:{"id":_vm.boxId},on:{"mousemove":_vm.mousemoveFn,"mouseover":_vm.mouseoverFn}},[_c('img',{attrs:{"src":_vm.src,"id":_vm.imgId,"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29630294","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/default/ImageShow.vue
// module id = null
// module chunks = 